var _rect, _circle, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 121,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 120,
    height: 120,
    rx: 60,
    fill: "#F1ECFF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60.5,
    r: 44,
    fill: "#5F30E2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42 81.9514V39.9426C42 39.1447 42.6455 38.5 43.4393 38.5H68.3096L78.0698 48.2733V81.9514C78.0698 82.7493 77.4243 83.394 76.6304 83.394H43.4393C42.6458 83.394 42 82.7496 42 81.9514Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8495 56.398H67.4723C67.6163 56.398 67.7329 56.5147 67.7329 56.6586C67.7329 56.8026 67.6163 56.9192 67.4723 56.9192H52.8495C52.7055 56.9192 52.5889 56.8026 52.5889 56.6586C52.5889 56.5147 52.7055 56.398 52.8495 56.398Z",
    fill: "#F2F2F2",
    stroke: "#C9B5FF",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8495 65.2223H67.4723C67.6163 65.2223 67.7329 65.3389 67.7329 65.4829C67.7329 65.6268 67.6163 65.7434 67.4723 65.7434H52.8495C52.7055 65.7434 52.5889 65.6268 52.5889 65.4829C52.5889 65.3389 52.7055 65.2223 52.8495 65.2223Z",
    fill: "#F2F2F2",
    stroke: "#C9B5FF",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8495 60.6841H67.4723C67.6163 60.6841 67.7329 60.8008 67.7329 60.9447C67.7329 61.0886 67.6163 61.2053 67.4723 61.2053H52.8495C52.7055 61.2053 52.5889 61.0886 52.5889 60.9447C52.5889 60.8008 52.7055 60.6841 52.8495 60.6841Z",
    fill: "#F2F2F2",
    stroke: "#C9B5FF",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8495 69.5082H67.4723C67.6163 69.5082 67.7329 69.6249 67.7329 69.7688C67.7329 69.9127 67.6163 70.0294 67.4723 70.0294H52.8495C52.7055 70.0294 52.5889 69.9127 52.5889 69.7688C52.5889 69.6249 52.7055 69.5082 52.8495 69.5082Z",
    fill: "#F2F2F2",
    stroke: "#C9B5FF",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7329 45.4802V39.9142L76.6556 46.8369H71.0895C70.3404 46.8369 69.7329 46.2296 69.7329 45.4802Z",
    fill: "white",
    stroke: "#C9B5FF",
    strokeWidth: 2
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon.b59e4432bf3e6d2cdd90d35e3490e0aa.svg";